import { Tooltip, Typography, List, ListItem, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TimeFilterTooltipProps {
    chartKey: number;
    timeFiltersFields: string[];
    children: React.ReactElement;
}

const TimeFilterTooltip = ({
    chartKey,
    timeFiltersFields,
    children,
}: TimeFilterTooltipProps) => {
    const { t } = useTranslation();
    if (timeFiltersFields.length === 0) {
        return (
            <Tooltip
                title={
                    <Typography variant="subtitle2" align="center">
                        {t('timeFilterTooltip.noTimeFilter')}
                    </Typography>
                }
            >
                {children}
            </Tooltip>
        );
    }

    const tooltipTitle = (
        <Box>
            <Typography variant="subtitle2">{`${t(
                'timeFilterTooltip.filterOn',
            )} :`}</Typography>
            <List>
                {timeFiltersFields.map((filter) => (
                    <ListItem key={`${chartKey}-${filter}`}>
                        <Typography variant="subtitle2">{filter}</Typography>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return <Tooltip title={tooltipTitle}>{children}</Tooltip>;
};

export default TimeFilterTooltip;
